import React from 'react';



type Props = {
  className?: string;
}
export const CheckVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M5 13L9 17L19 7' />
    </svg>
  );
};
